import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { HeaderSide } from "./headerside"
import style from './style.module.css'
import { MapWithPoligons } from "../../MapWithPoligons";
import L from "leaflet";
import { Table } from "./Table";
import { Graph1 } from "./graph1";
import { Graph2 } from "./graph2";
import { Select } from "antd";
import { useGetStorageListQuery } from "../../../redux/api/organic/storageApi";
import { EntStorageFilter } from "../../../models/filters/organic/storageFilter";
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";
import SelectTerritorialUnitsCode from "../../selects/SelectTerritorialUnitsCode";
import i18n from "i18next";

const customMarkerIcon = L.icon({
    iconUrl: "/imort.svg",
    iconSize: [35, 55],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });


export const StorageAnalitical = () => {
    const { t } = useTranslation();

    const [filters, setFilters] = useState<EntStorageFilter>(new EntStorageFilter({
      yearReported: 2025,
      page: 1,
      size: 10000,
      deleted: false
    }));

    const { data: storageData, isLoading: storageLoading } = useGetStorageListQuery(filters);

    const handleRegionChange = (regionId: string | number) => {
      const numericRegionId = typeof regionId === 'string' ? parseInt(regionId, 10) : regionId;

      if (numericRegionId === 0) {
        setFilters((prev) => {
          const newFilters = { ...prev };
          delete newFilters.regionId;
          return { ...newFilters, page: 1 };
        });
      } else {
        setFilters((prev) => ({
          ...prev,
          regionId: numericRegionId,
          page: 1,
        }));
      }
    };

    const handleYearChange = (year: number | null) => {
      setFilters((prev) => ({
        ...prev,
        yearReported: year || new Date().getFullYear(),
        page: 1,
      }));
    };

    const handleResetFilters = () => {
      setFilters(new EntStorageFilter({
        yearReported: 2025,
        page: 1,
        size: 10000,
        deleted: false
      }));
    };

    const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

    const mapData = React.useMemo(() => {
      if (!storageData?.success || !storageData?.res?.content) {
        return [];
      }

      return storageData.res.content.map((storage) => ({
        latitude: storage.latitude || 0,
        longitude: storage.longitude || 0,
        name: storage.storageName || 'Хранилище',
        address: `${storage.region?.nameRu || 'Не указан'}, ${storage.area?.nameRu || 'Не указан'}`,
        type: "Хранилище",
        popupContent: `
          <div style="padding: 8px;">
            <h4 style="margin: 0 0 8px 0; color: #333; font-size: 16px;">
              ${storage.storageName || 'Без названия'}
            </h4>
            <p style="margin: 4px 0; color: #666;">
              <strong style="color: #333;">Регион:</strong> ${i18n.language === 'ru' ? storage.region?.nameRu : storage.region?.nameKy || 'Не указан'}
            </p>
            <p style="margin: 4px 0; color: #666;">
              <strong style="color: #333;">Район:</strong> ${i18n.language === 'ru' ? storage.area?.nameRu : storage.area?.nameKy || 'Не указан'}
            </p>
            <p style="margin: 4px 0; color: #666;">
              <strong style="color: #333;">Юридическое лицо:</strong> ${storage.legalEntity || 'Не указан'}
            </p>
            <p style="margin: 4px 0; color: #666;">
              <strong style="color: #333;">Статус:</strong> ${i18n.language === 'ru' ? storage.registerStatus?.nameRu : storage.registerStatus?.nameKy || 'Не указан'}
            </p>
            <p style="margin: 4px 0; color: #666;">
              <strong style="color: #333;">Мощность:</strong> ${storage.capacity?.capacityTonnes || 0} т
            </p>
            <p style="margin: 4px 0; color: #666;">
              <strong style="color: #333;">Холодильные камеры:</strong> ${storage.capacity?.coldStorageVolumeM3 || 0} м³
            </p>
            <p style="margin: 4px 0; color: #666;">
              <strong style="color: #333;">Тип хранилища:</strong> ${i18n.language === 'ru' ? storage.capacity?.storageType?.nameRu : storage.capacity?.storageType?.nameKy || 'Не указан'}
            </p>
            <p style="margin: 4px 0; color: #666;">
              <strong style="color: #333;">Тип продукции:</strong> ${i18n.language === 'ru' ? storage.capacity?.productType?.nameRu : storage.capacity?.productType?.nameKy || 'Не указан'}
            </p>
          </div>
        `
      }));
    }, [storageData]);

    const regionName = storageData?.res?.content?.[0]?.region?.nameRu || "-";

    const storageNames = storageData?.res?.content?.map(storage => storage.storageName || '') || [];

    return (
        <div >
        <HeaderSide />
        <div className={style.container}>
            <div className={style.map}>
            <div className={style.content}>
                <div className={style.mapFiltersOnMap}>
                  <Select
                    style={{ width: 120 }}
                    value={filters.yearReported}
                    onChange={handleYearChange}
                    placeholder={t("Выберите год")}
                  >
                    {years.map((year) => (
                      <Select.Option key={year} value={year}>
                        {year}
                      </Select.Option>
                    ))}
                  </Select>

                  <SelectTerritorialUnitsCode
                  type={["REGION"]}
                  value={filters.regionId}
                  onChange={handleRegionChange}
                />
                   <button className={style.resetBtn} onClick={handleResetFilters}>
                    Сбросить
                  </button>
                </div>
                <MapWithPoligons
                     extraData={mapData}
                              latitude={41.5089324}
                              longitude={74.724091}
                              customIcon={customMarkerIcon}
                              type = {["REGION"]}
                              selectedYear={filters.yearReported}
                />
            </div>
            <div className={style.table}>
                <Table regionName={regionName} storageNames={storageNames} />
            </div>
            </div>
            {storageLoading && <PreloaderSvg />}
        </div>
        <div className={style.graphs}>
        <div className={style.graph1}>
            <Graph1 />
        </div>
        <div className={style.graph2}>
            <Graph2 />
        </div>
        </div>
        </div>
    )
}